﻿import React, { useContext, useState } from 'react';
import { Helmet } from "react-helmet";
import Context, { context_type } from '@Util/Context';
import { useTranslation } from 'react-i18next';
import { str_isEmpty } from '@Util/Utils';
import { Customer } from '@Util/Types';

import { H2 } from '@Elements/Fonts';
import Page_Header from '@Elements/Page_Header';
import Projects_Table from '@Elements/Projects_Table';
import Add_Project_Popup from '@Modules/Popups/Add_Project_Popup';
import { Plus_Button } from '@Elements/Buttons';

export default function Projectspage(): JSX.Element {
    const [t] = useTranslation();
    const { customers, current_project }: context_type = useContext(Context);
    const [add_project_popup_open, set_add_project_popup_open] = useState<boolean>(false);
    const [add_project_customer_id, set_add_project_customer_id] = useState<number>(0);

    return (
        <div className="Page_Content_InnerNarrow">
            <Helmet>
                <title>{`${t('Navigation.Projects')} - InTime`}</title>
            </Helmet>
            <Page_Header headline={t('Navigation.Projects')} />
            {customers?.map((customer: Customer, index: number): JSX.Element =>
                <React.Fragment key={`projectsListItem${index}`}>
                    <div className="Headline_Wrapper--WithAction">
                        <H2 className="Headline--VerticallyAligned">
                            <>
                                {
                                    !str_isEmpty(customer.color) &&
                                    <span
                                        className="Customer_Color"
                                        style={{ backgroundColor: `rgb(${customer.color})` }}
                                        aria-label="hidden"
                                    ></span>
                                }
                                {customer.name}
                            </>
                        </H2>
                        <Plus_Button
                            aria_name={t('Text.AddProject')}
                            onClick={() => {
                                set_add_project_customer_id(customer.id);
                                set_add_project_popup_open(true);
                            }}
                        />
                    </div>
                    <Projects_Table
                        projects={customer.projects}
                        current_project={current_project}
                    />
                </React.Fragment>
            )}
            <Add_Project_Popup
                open={add_project_popup_open}
                set_open={set_add_project_popup_open}
                customer_id={add_project_customer_id}
                set_customer_id={set_add_project_customer_id}
            />
        </div>
    );
}